module.exports = __webpack_public_path__ + "img/fluent-drag-black-used.2083be6f.svg";